import React from 'react'
import styled from 'styled-components'
import { StaticImage } from "gatsby-plugin-image"

import {ButtonWhite} from './ui/btn'

const ContainerStyle  = styled.div`
    background-color: #000000;
`;

const FooterStyle = styled.footer`
    padding: 2em 2em 4em 2em;  
    color: #ffffff;
 
    p{
        font-size: 1em;
    }
    a{
        color: #ffffff;
    }
    @media (min-width: 769px) {
        max-width: 1620px;
        margin: 0 auto;
        padding: 4em 4em 4em 4em;  
    }
`;

const GridStyle = styled.div`
    display: grid;
    text-align: center;
    gap: 2em;
    @media (min-width: 769px) {
        grid-template-columns: repeat( 3, 1fr);    
        gap: 4em;
        text-align: left;
    }
    @media (min-width: 1028px) {
        grid-template-columns: repeat( 3, 1fr);    
        gap: 10em;
        text-align: left;
    }    
`;

const Newsletter = styled.div` 
    text-align: center;
    margin-top: .5em;
    a{
        color: #000000;
        font-weight: bold;
    }
    @media (max-width: 1029px) {
        display: none
    }
`;

const NewsletterMobile = styled.div`    
    margin-top: .5em;
    a{
        color: #000000;
        font-size: .9em !important;
        font-weight: bold;
    }
    @media (min-width: 1029px) {
        display: none
    }
`;


const Redes = styled.div`    
    display: flex;
    align-items: top;
    justify-content: space-around;    
`;

const Legales = styled.div`
    padding-top: 4em;
    gap: 10px;
    text-align: center;
    a{
        font-size: .9em;
    }
    @media (min-width: 769px) {        
        display: flex;
        justify-content: center;
        align-items: center;
    }
`;

const Footer = () => {
    return ( 
        <ContainerStyle>
            <FooterStyle>
                <GridStyle>
                    <div>
                        <p>Centro de diseño, cine y televisión</p>
                        <p>
                            <StaticImage
                                src="../images/ubicacion.png"
                                width={15}
                                quality={100}
                                formats={["AUTO", "WEBP", "AVIF"]}
                                alt="Facebook"
                            />
                            <a href="https://www.google.com/maps/place/Av+Constituyentes+455,+Am%C3%A9rica,+11820+Ciudad+de+M%C3%A9xico,+D.F.,+M%C3%A9xico/@19.4050823,-99.2041658,17z/data=!3m1!4b1!4m2!3m1!1s0x85d201c266b9342b:0xd2a8710bf56baf61" target="_blank" rel="noreferrer"> Av. Constituyentes 455, CDMX</a></p>
                        <p>
                            <StaticImage
                                src="../images/tel.png"
                                width={14}
                                quality={100}
                                formats={["AUTO", "WEBP", "AVIF"]}
                                alt="Facebook"
                            />                            
                            <a href="tel:5527899000" target="_blank" rel="noreferrer"> +(52) 55 2789 9000</a>
                        </p>
                    </div>
                    <Newsletter>            
                        <ButtonWhite href="https://www3.centro.edu.mx/suscripcion-newsletter/" target="_blank" rel="noreferrer">Suscríbete a nuestro newsletter</ButtonWhite>                        
                    </Newsletter>
                    <NewsletterMobile>            
                        <ButtonWhite href="https://www3.centro.edu.mx/suscripcion-newsletter/" target="_blank" rel="noreferrer">Suscribir a newsletter</ButtonWhite>                        
                    </NewsletterMobile>
                    <Redes> 
                        <a href="https://www.facebook.com/centro.edu.mx" target="_blank" rel="noreferrer">
                            <StaticImage
                                src="../images/facebook.png"
                                width={32}
                                quality={100}
                                formats={["AUTO", "WEBP", "AVIF"]}
                                alt="Facebook"
                                />
                        </a>
                        <a href="https://www.instagram.com/centro_U/" target="_blank" rel="noreferrer">
                            <StaticImage
                                src="../images/instagram.png"
                                width={32}
                                quality={100}
                                formats={["AUTO", "WEBP", "AVIF"]}
                                alt="Instagram"
                                />
                        </a>
                        <a href="https://twitter.com/centro_news" target="_blank" rel="noreferrer">
                            <StaticImage
                                src="../images/twitter.png"
                                width={32}
                                quality={100}
                                formats={["AUTO", "WEBP", "AVIF"]}
                                alt="Twitter"
                                />
                        </a>
                        <a href="https://www.linkedin.com/school/centro.edu.mx/" target="_blank" rel="noreferrer">
                            <StaticImage
                                src="../images/linkedin.png"
                                width={32}
                                quality={100}
                                formats={["AUTO", "WEBP", "AVIF"]}
                                alt="LinkedIn"
                                />
                        </a>   
                        <a href="https://www.youtube.com/channel/UC40YNTjmtfGfYOmogaPvXHQ" target="_blank" rel="noreferrer">
                            <StaticImage
                                src="../images/youtube.png"
                                width={32}
                                quality={100}
                                formats={["AUTO", "WEBP", "AVIF"]}
                                alt="Youtube"
                                />
                        </a> 
                        <a href="https://www.tiktok.com/@centro.edu.mx" target="_blank" rel="noreferrer">
                            <StaticImage
                                src="../images/tiktok.png"
                                width={32}
                                quality={100}
                                formats={["AUTO", "WEBP", "AVIF"]}
                                alt="Youtube"
                                />
                        </a>                         
                                                                                                                  
                    </Redes>
                </GridStyle>
                <Legales>
                        <a href="https://www3.centro.edu.mx/" target="_blank" rel="noreferrer">CENTRO {new Date().getFullYear()}</a> | 
                        <a href="https://www3.centro.edu.mx/wp-content/themes/centro/Legales/CentroAvisoDePrivacidad.html" target="_blank" rel="noreferrer"> Aviso de Privacidad</a> | 
                        <a href="https://www3.centro.edu.mx/wp-content/themes/centro/Legales/Centro_terminos_y_condiciones.html" target="_blank" rel="noreferrer"> Terminos y Condiciones</a> | 
                        <a href="https://www3.centro.edu.mx/wp-content/themes/centro/Legales/Texto_excluyente_de_responsabilidad.html" target="_blank" rel="noreferrer"> Aviso Legal</a> | 
                        <a href="http://www.santander.com.mx/NuevaVersion/index.html" target="_blank" rel="noreferrer"> Santander</a>                
                </Legales>
            </FooterStyle>
        </ContainerStyle>
     );
}
 
export default Footer;
